import React from 'react';
import OrderProductionUtil from "../../../../../../utils/OrderProductionUtil";

const CellOPTm = ({cell2, row, cellEstimate, requestsPurchase, bigCell, white, green}) => {
    const header = cell2.column.id;
    const cell = cellEstimate !== undefined ? cellEstimate : OrderProductionUtil.getValueByHeader(row.original.packageJobs, header);
    let backgroundColor;
    let displayValue;

    if (cell === null || cell === undefined) {
        backgroundColor = 'white';
        displayValue = 'n';
    } else if ((cell >= 100 && !requestsPurchase) || green) {
        backgroundColor = 'rgba(22, 184, 44, 0.5)';
        displayValue = green ? Math.floor(cell) : '+';
    } else if (cell < 0) {
        backgroundColor = undefined;
        displayValue = 'n';
    } else {
        backgroundColor = (cell === 0 && (requestsPurchase || white)) ? 'white' : 'rgba(240, 130, 12, 1)';
        displayValue = cell < 1 ? Math.ceil(cell) : Math.floor(cell);
    }

    return (
        <span style={{
            padding: (cell > 9 && cell < 100 && bigCell) ? "8px 12px" : (bigCell && (cell < 10 || (cell === 100 && !requestsPurchase))) ? "8px 16px" : bigCell ? "8px" : (cell > 9 && cell < 100) ? "8px" : "8px 12.5px",
            backgroundColor: backgroundColor,
        }}>
            {displayValue}
        </span>
    );
};

export default CellOPTm;